<template>
  <div v-if="!isVisitor && isEnabled">
    <SiteNavFull
      :active="active"
      :links="links"
      :advisor="advisor"
      :features="features"
      :open="open"
      @toggled="toggle"
      @sized="updateWidth"
    />

    <!-- <ExpandX :open='open' @sized='updateSize'>
      <SiteNavFull @toggled='toggle' :active='active' :links='links' :advisor='advisor'/>
    </ExpandX> -->

    <!--
    Mini version scrapped per team feedback
    Will probably need to remove this code, but leaving it for now.

    <Transition name='slide-v'>
      <SiteNavMini @toggled='toggle' :active='active' v-if='!open'/>
    </Transition>
    -->
  </div>
</template>


<script>
import SiteNavFull from './components/SiteNavFull.vue';
// import SiteNavMini from './components/SiteNavMini.vue'
import ExpandX from '../../components/ExpandX.vue';
import links from './links.js';


export default {
  name: 'SiteNav',
  components: { SiteNavFull, /* SiteNavMini,*/ ExpandX },
  props: ['advisorData'],
  data() {
    return {
      open: false,
      width: 0,
      links,
      embeddedAdvisor: null,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    advisor() {
      return this.advisorData || this.embeddedAdvisor;
    },
    // Duplicated here because features only exists in FrontendRoot.vue when on ui/ routes
    // Site nav must work everywhere and cannot depend on that (yet)
    features() {
      const flags = this.advisor?.user?.feature_flags;
      const names = flags?.map(f => f.replace(/[Ff]eature:?\s+/, '').trim());
      // Return a hash of enabled feature names
      return names?.reduce((hash, name) => ({ ...hash, [name]: true }), {});
    },
    isEnabled() { // Only use new nav if feature flag exists
      const flags = this.advisor?.user?.feature_flags;
      if (!flags) return false;
      return flags.includes('Feature: Nav');
    },
    route() {
      if (!this.$route) return null;

      return {
        path: this.$route.path,
        name: this.$route.name,
      };
    },
    isVisitor() {
      if (this.advisor?.is_visitor) return true;
      return this.route?.path?.startsWith('/visitor/');
    },
    activePath() {
      const raw = this.route?.path || window.location.pathname;
      return this.clean(raw);
    },

    // Find the currently active section and page
    active() {
      for (const section of this.links) {
        // If section itself is a link, check that first.
        if (section.link) {
          if (this.clean(section.link.path) === this.activePath) {
            return { section };
          }
        }

        // Loop through all links in section. Look for match to active path.
        if (section.links) {
          for (const link of section.links) {
            if (this.clean(link.path) === this.activePath) {
              return { section, link };
            }
          }
        }
      }
      return {};
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.getEmbeddedAdvisor();
    window.setTimeout(() => this.open = true, 500);
  },
  updated() {},
  methods: {
    toggle() {
      this.open = !this.open;
    },
    clean(s) {
      if (!s) return null;
      s = s.trim();
      if (s[0] === '/') s = s.substring(1);

      const n = s.length;
      return s[n - 1] === '/' ? s.substring(0, n - 1) : s;
    },
    getEmbeddedAdvisor() {
      const elem = document.getElementById('ADVISOR_JSON');
      this.embeddedAdvisor = JSON.parse(elem.textContent);
    },
    updateWidth(width) {
      this.width = width;
    },
  },
};
</script>


<style scoped>
  .slide-h-enter-active,
  .slide-h-leave-active,
  .slide-v-enter-active,
  .slide-v-leave-active {
    transition: all 0.5s;
  }

  .slide-h-enter, .slide-h-leave-to {
    opacity: 0;
    transform: translateX(-100%);
  }

  .slide-v-enter, .slide-v-leave-to {
    opacity: 0;
    transform: translateY(-100%);
  }
</style>
